var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-finish-view" }, [
    _c("div", { staticClass: "c-view-container" }, [
      _c("div", [
        _c("h1", { staticClass: "c-finish-view__heading" }, [
          _vm._v(_vm._s(_vm.Finished.FinishedViewTitle)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-view-container__inner" }, [
          _c(
            "div",
            { staticClass: "c-finish-view-content-col c-view-content-col" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "c-finish-view-content-col__inner c-view-content-col__inner",
                },
                [
                  _c("div", { staticClass: "c-finish-view-tips" }, [
                    _c("h2", { staticClass: "c-finish-view-tips__heading" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.Finished.FinishedViewTipTitle) +
                          "\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "c-finish-view-tips__inner" }, [
                      _vm.Finished.FinishedViewTipOne != ""
                        ? _c("div", { staticClass: "c-finish-view-tip" }, [
                            _c("img", {
                              staticClass: "c-finish-view-tip__image",
                              attrs: {
                                src: "_resources/app/client/assets/images/coin.svg",
                                alt: "coin",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "c-finish-view-tip__text" },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.Finished.FinishedViewTipOne
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.Finished.FinishedViewTipTwo != ""
                        ? _c("div", { staticClass: "c-finish-view-tip" }, [
                            _c("img", {
                              staticClass: "c-finish-view-tip__image",
                              attrs: {
                                src: "_resources/app/client/assets/images/coin.svg",
                                alt: "coin",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "c-finish-view-tip__text" },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.Finished.FinishedViewTipTwo
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "c-finish-view-content" }, [
                    _c("div", {
                      staticClass: "c-finish-view-content__text",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.Finished.FinishedViewResourcesContent
                        ),
                      },
                    }),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "c-view-controls__wrapper" }, [
      _c("div", { staticClass: "c-view-controls" }, [
        _c(
          "div",
          { staticClass: "c-view-controls__inner c-view-controls__inner--end" },
          [
            _c(
              "div",
              { staticClass: "c-view-finish__controls" },
              [
                _c("EmailYourSavingsButton"),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "u-calc-button",
                    on: { click: _vm.resetCalculator },
                  },
                  [
                    _c("p", [_vm._v("Back to the start")]),
                    _vm._v(" "),
                    _c("span"),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }